/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;
Wrapper.displayName = 'Wrapper';

export const ButtonContainer = styled.div`
  display: flex;
  padding-left: 10px;
`;
Wrapper.displayName = 'Wrapper';
